import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-o-que-e {
  padding: 0 0 319px;
  position: relative;
}

#emp-garantia-carro-o-que-e .ctn-home-24 {
  z-index: 3;
  position: relative;
}

#emp-garantia-carro-o-que-e .o-que-e-titulo {
  margin: 0;
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#emp-garantia-carro-o-que-e .o-que-e-subtitulo {
  margin-top: 8px;
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; 
}

#emp-garantia-carro-o-que-e .o-que-e-subtitulo b {
  font-weight: 600;
}

#emp-garantia-carro-o-que-e .o-que-e-cards {
  margin-top: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

#emp-garantia-carro-o-que-e .o-que-e-cards .o-que-e-card-sinal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

#emp-garantia-carro-o-que-e .o-que-e-cards .o-que-e-card {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 121px;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #C00;
}

#emp-garantia-carro-o-que-e .o-que-e-cards .o-que-e-card-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#emp-garantia-carro-o-que-e .o-que-e-cards .o-que-e-card-resultado {
  display: flex;
  flex-direction: column;
  width: 220px;
  height: 121px;
  padding: 8px 8px 8px 16px;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #C00;
  background: #DEEDF2;
}

#emp-garantia-carro-o-que-e .btn-o-que-e-simular {
  max-width: 272px;
  width: 100%;
  height: 48px;
  margin: 40px auto 0;
}

#emp-garantia-carro-o-que-e .santander-symbol {
  background-image: url('assets/emprestimo-garantia-carro/santander-symbol.webp'),
      url('assets/emprestimo-garantia-carro/santander-symbol.png');
  width: 694px;
  height: 616px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-size: cover;
}

#emp-garantia-carro-o-que-e .o-que-e-car {
  position: absolute;
  bottom: 27px;
  right: 0;
}

@media (min-width: 992px) {
  #emp-garantia-carro-o-que-e {
    padding: 0 0 80px;
  }

  #emp-garantia-carro-o-que-e .o-que-e-titulo {
    font-size: 56px;
    line-height: 120%;
    max-width: 570px;
  }

  #emp-garantia-carro-o-que-e .o-que-e-subtitulo {
    margin-top: 14px;
  }

  #emp-garantia-carro-o-que-e .o-que-e-cards {
    flex-direction: row;
    align-items: flex-start;
    gap: 32px;
  }

  #emp-garantia-carro-o-que-e .o-que-e-cards .o-que-e-card-sinal {
    flex-direction: row;
    gap: 32px;
  }

  #emp-garantia-carro-o-que-e .btn-o-que-e-simular {
    margin: 88px 0 0;
  }

  #emp-garantia-carro-o-que-e .o-que-e-car {
    bottom: -56px;
  }
}`;

export default styles;